import { useCallback, useEffect, useRef, useState } from 'react'

const useCategoryResizer = ({
  isDropdownOpen,
  chips,
  value = 'valueWithModify',
}) => {
  const [visibleChipsCount, setVisibleChipsCount] = useState(0)
  const containerRef = useRef(null)
  const measurementRef = useRef(null)

  const updateVisibleChipsCount = useCallback(() => {
    const gapWidth = 4
    const indicatorWidth = 34
    if (containerRef.current && measurementRef.current) {
      const containerWidth = containerRef.current.getBoundingClientRect().width
      let totalChipsWidth = 0
      let count = 0

      for (let i = 0; i < chips.length; i++) {
        const text = typeof chips[i] === 'object' ? chips[i][value] : chips[i]

        measurementRef.current.innerText = text
        const chipWidth =
          measurementRef.current.getBoundingClientRect().width + gapWidth
        totalChipsWidth += chipWidth

        if (totalChipsWidth > containerWidth - indicatorWidth) {
          break
        }

        count += 1
      }

      setVisibleChipsCount(count || 1)
    }
  }, [isDropdownOpen, chips, value])

  useEffect(() => {
    updateVisibleChipsCount()
    window.addEventListener('resize', updateVisibleChipsCount)

    return () => {
      window.removeEventListener('resize', updateVisibleChipsCount)
    }
  }, [chips.length])

  const hiddenChipsCount = chips.length ? chips.length - visibleChipsCount : 0

  return {
    hiddenChipsCount,
    visibleChipsCount,
    containerRef,
    measurementRef,
  }
}

export default useCategoryResizer
